import { useTranslation } from 'react-i18next'
import EmptyListTemplate from './EmptyListTemplate'
import LocalHeader from './LocalHeader'

const HeaderWith404 = () => {
  const {t} = useTranslation()
  return <>
    <LocalHeader title={t('error.404_title')} back='/'/>
    <EmptyListTemplate
      title={t('error.404_title')}
      icon='heart_broken'
      description={t('error.404_description')}
    />
  </>
}
export default HeaderWith404